import { useEffect, useState } from "react"
import { createUseStyles } from 'react-jss'
import { useAppSelector } from "../redux/hooks"
import { useAppDispatch } from '../redux/hooks'
import {
    Shift,
    ShiftListFilter,
} from "../redux/types"
import FullScreenLoadingIndicator from "../components/FullScreenLoadingIndicator"
import Card from "../components/Card"
import useShiftActions from "../hooks/useShiftActions"
import { pageIndexChanged, filterChanged, errorHandled } from "../redux/slices/shiftSlice"
import ShiftList from "../components/ShiftList/ShiftList"
import FilterComponent from "../components/ShiftList/ShiftListFilter"
import useDidUpdateEffect from "../hooks/useDidUpdateEffect"
import { useTranslation } from "react-i18next"
import ErrorModal from "../components/ErrorModal"
import { useNavigate } from "react-router-dom"

const Shifts = () => {
    const styles = useStyles()
    const { t } = useTranslation(['shifts', 'common']);
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const [errorModalVisible, setErrorModalVisible] = useState<boolean>(false)

    const { getShifts } = useShiftActions()
    const loading = useAppSelector(state => state.shift.loading)
    const shiftsOnPage = useAppSelector(state => state.shift.shiftsOnPage)
    const totalShiftCount = useAppSelector(state => state.shift.totalShiftCount)
    const pageIndex = useAppSelector(state => state.shift.pageIndex)
    const pageSize = useAppSelector(state => state.shift.pageSize)
    const filter = useAppSelector(state => state.shift.filter)
    const error = useAppSelector(state => state.shift.error)

    useEffect(() => {
        if (shiftsOnPage.length === 0)
            getShifts(filter?.employeeId ?? undefined, filter?.fromDate ?? undefined, filter?.toDate ?? undefined, filter?.status ?? undefined, filter?.type ?? undefined, pageIndex, pageSize)
    }, [])

    useDidUpdateEffect(() => {
        getShifts(filter?.employeeId ?? undefined, filter?.fromDate ?? undefined, filter?.toDate ?? undefined, filter?.status ?? undefined, filter?.type ?? undefined, pageIndex, pageSize)
    }, [filter, pageIndex])

    useDidUpdateEffect(() => {
        if (error) {
            setErrorModalVisible(true)
        }
    }, [error])

    const handleError = () => {
        dispatch(errorHandled())
        setErrorModalVisible(false)
    }

    const onShiftClick = (shift: Shift) => {
         navigate(`/shifts/${shift.id}`)
    }

    const onPageChange = (pageIndex: number) => {
        dispatch(pageIndexChanged(pageIndex))
    }

    const handleFilterChange = (filter: ShiftListFilter) => {
        dispatch(filterChanged(filter))
    }

    return (
        <>
        <Card className={styles.card}>
            <h2>
            {t('title', {ns: 'shifts'})}
            </h2>
        </Card>
        <Card>
            <div className={styles.filterContainer}>
                <FilterComponent
                    initialFilterValue={filter ?? undefined}
                    onFilterChange={handleFilterChange}
                />
            </div>
            {shiftsOnPage &&
            <ShiftList
                shiftsOnPage={shiftsOnPage}
                pageIndex={pageIndex}
                pageSize={pageSize}
                totalShiftCount={totalShiftCount}
                onShiftClick={onShiftClick}
                onPageChange={onPageChange}
            />}
            <ErrorModal
                visible={errorModalVisible}
                errorText={error?.toString()}
                onCloseClick={handleError}
            />
            <FullScreenLoadingIndicator visible={loading} />
        </Card>
        </>
    )
}

export default Shifts

const useStyles = createUseStyles({
    card: {
        marginBottom: 20
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        marginBottom: 20,
        gap: 10
    },
    filterContainer: {
        marginBottom: 20,
    },
    button: {
        alignSelf: 'flex-end'
    }
})
